<template>
  <SectionContainerPage>
    <v-layout column>
      <v-flex>
        <SectionAttachmentDetail
          :breadCrumbs="breadCrumbs"
          :title="attachmentDetail.fileName"
          @onClickBreadcrumb="(val) => $emit('onClickBreadcrumb', val)"
          :toolbarActions="[
            {
              text: 'Edit Attachment',
              icon: 'edit',
              iconColor: 'warning',
              emitEvent: 'onEditAttachmentClicked',
            },
            {
              text: 'Download',
              icon: 'get_app',
              iconColor: 'info',
              emitEvent: 'onDownloadClicked',
            },
          ]"
          @onEditAttachmentClicked="showDialogFormAttachmentEdit = true"
          @onDownloadClicked="fetchAttachmentFile"
          :attachmentDetail="attachmentDetail"
          :modelList="modelList"
          :manufacturerList="manufacturerList"
          :categoryList="categoryList"
          :activityTypeList="activityTypeList"
          :locationList="locationList"
          :clientList="clientList"
          :userList="userList"
          :isLoading="isLoading"
        />
      </v-flex>
      <v-flex>
        <v-tabs dark v-model="currentTab">
          <v-tab>
            <v-icon class="mr-1">construction</v-icon
            >{{
              `Equipment (${
                (attachmentDetail.assetList &&
                  attachmentDetail.assetList.length) ||
                0
              })`
            }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">event</v-icon
            >{{
              `Activities (${
                (attachmentDetail.activityList &&
                  attachmentDetail.activityList.length) ||
                0
              })`
            }}
          </v-tab>
        </v-tabs>
      </v-flex>
      <v-flex v-if="currentTab === tabAssets">
        <SectionAssetList
          xs12
          :isPrimary="false"
          title="Equipment"
          @onClickViewEquipment="
            (val) =>
              $emit('onClickViewEquipmentFromAttachmentDetail', {
                ...val,
                breadCrumbTitle: attachmentDetail.fileName,
              })
          "
          :shouldShowCheckBoxes="false"
          :assetList="attachmentDetail.assetList || []"
          :modelList="modelList"
          :manufacturerList="manufacturerList"
          :categoryList="categoryList"
          :activityTypeList="activityTypeList"
          :assetStatusList="assetStatusList"
          :locationList="locationList"
          :clientList="clientList"
          :userList="userList"
          :isLoading="isLoading"
        />
      </v-flex>
      <v-flex v-if="currentTab === tabActivities">
        <SectionActivityList
          xs12
          :isPrimary="false"
          title="Activity"
          :activityList="attachmentDetail.activityList || []"
          :activityTypeList="activityTypeList"
          :assetStatusList="assetStatusList"
          :locationList="locationList"
          :userList="userList"
          :modelList="modelList"
          @onClickViewActivity="
            (val) =>
              $emit('onClickViewActivityFromAttachmentDetail', {
                ...val,
                breadCrumbTitle: attachmentDetail.fileName,
              })
          "
          :isLoading="isLoading"
        />
      </v-flex>
    </v-layout>
    <DialogFormAttachmentEdit
      :showDialog="showDialogFormAttachmentEdit"
      @onCancelClicked="showDialogFormAttachmentEdit = false"
      @onSubmitClicked="
        (val) => [
          onDialogFormAttachmentEditSubmit(val),
          (showDialogFormAttachmentEdit = false),
        ]
      "
      :attachmentToEdit="attachmentDetail"
      :activityTypeList="activityTypeList"
      :userList="userList"
      :locationList="locationList"
      :modelList="modelList"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionAttachmentDetail from './sections/SectionAttachmentDetail'
import SectionAssetList from './sections/SectionAssetList'
import SectionActivityList from './sections/SectionActivityList'

import DialogFormAttachmentEdit from '../dialogs/DialogFormAttachmentEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

const TAB_ASSETS = 0
const TAB_ACTTIVITIES = 1

export default {
  components: {
    SectionContainerPage,
    SectionAttachmentDetail,
    SectionAssetList,
    SectionActivityList,

    DialogFormAttachmentEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {
    attachmentId: {
      type: Number,
      required: true,
    },
    breadCrumbs: Array,
  },
  data: () => ({
    currentTab: TAB_ASSETS,
    tabAssets: TAB_ASSETS,
    tabActivities: TAB_ACTTIVITIES,
    showDialogFormAttachmentEdit: false,
    showDialogConfirmation: false,
    attachmentDetail: {},
    modelList: [],
    manufacturerList: [],
    categoryList: [],
    activityTypeList: [],
    assetStatusList: [],
    locationList: [],
    clientList: [],
    userList: [],
    isLoadingCount: 0,
  }),
  activated() {
    this.currentTab = this.tabAssets
    this.fetchAttachmentDetail()
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    fetchAttachmentFile() {
      this.isLoadingCount++
      this._fetchAttachmentFile({
        attachmentId: this.attachmentId,
        successCb: (blob) => {
          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', this.attachmentDetail.fileName)
          document.body.appendChild(fileLink)
          fileLink.click()
          this.isLoadingCount--
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onConfirmUnlinkAttachment({ attachmentId, fileName } = {}) {
      this.showConfirmationDialog({
        submitButtonText: 'Unlink',
        submitButtonIcon: 'link_off',
        submitButtonColor: 'error',
        message:
          `Please confirm that you would like to unlink attachment "${fileName}" from this ` +
          this._entityPropertyValueByName({
            entityList: this.activityTypeList,
            idKey: 'id',
            idValue: this.attachmentDetail.typeId,
            propertyKey: 'name',
          }) +
          ' activity.',
        submitCb: () => {
          this.isLoadingCount++
          this._deleteAttachmentLink({
            data: {
              attachmentId: attachmentId,
            },
            successCb: () => {
              this.isLoadingCount--
              this.fetchAttachmentDetail()
              this.$emit('notify', {
                message: 'Attachment successfully unlinked!',
              })
            },
            failedCb: (error) => {
              this.isLoadingCount--
              this.showConfirmationDialog({
                title: 'Error occured',
                showCancelButton: false,
                message: this._getMessageFromErrorResponse(error),
                submitButtonText: 'Continue',
              })
            },
          })
        },
        cancelCb: () => {},
      })
    },
    onDialogFormAttachmentEditSubmit(data) {
      this.isLoadingCount++
      this._updateAttachment({
        id: this.attachmentId,
        comments: data.comments,
        successCb: () => {
          this.isLoadingCount--
          this.fetchAttachmentDetail()
          this.$emit('notify', { message: 'Attachment successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchAttachmentDetail() {
      this.isLoadingCount++
      this._fetchAttachmentDetail({
        attachmentId: this.attachmentId,
        successCb: (data) => {
          this.isLoadingCount--
          this.attachmentDetail = data
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: [
          'Status',
          'Model',
          'Manufacturer',
          'Category',
          'ActivityType',
          'Location',
          'Client',
          'User',
        ],
        successCb: (data) => {
          this.isLoadingCount--
          this.assetStatusList = data.statuses
          this.modelList = data.models
          this.manufacturerList = data.manufacturers
          this.categoryList = data.categories
          this.activityTypeList = data.activityTypes
          this.locationList = data.locations
          this.clientList = data.clients
          this.userList = data.users
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.assetStatusList = []
          this.modelList = []
          this.manufacturerList = []
          this.categoryList = []
          this.activityTypeList = []
          this.locationList = []
          this.clientList = []
          this.userList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
